<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-tooltip effect="dark" content="添加新的快递公司" placement="top">
              <el-button 
                type="primary" 
                size="mini" 
                icon="el-icon-plus" 
                @click="addButton()"
                class="action-btn">
                添加快递
              </el-button>
            </el-tooltip>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <i class="el-icon-search"></i>
            <span>筛选条件</span>
            <el-button 
              type="text" 
              size="mini" 
              icon="el-icon-refresh" 
              @click="resetSearch"
              class="reset-all-btn">
              重置全部
            </el-button>
          </div>
          <div class="search-content">
            <el-form size="mini" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item>
                <el-input 
                  v-model="searchCondition.express_name" 
                  placeholder="请输入快递公司名称" 
                  clearable
                  prefix-icon="el-icon-truck"
                  class="search-input">
                </el-input>
            </el-form-item>
              
            <el-form-item>
                <el-button 
                  type="primary" 
                  size="mini"
                  @click="searchButton"
                  icon="el-icon-search"
                  class="search-btn">
                  查询
                </el-button>
                <el-button 
                  size="mini"
                  @click="resetSearch"
                  icon="el-icon-refresh"
                  class="reset-btn">
                  重置
                </el-button>
            </el-form-item>
          </el-form>
          </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <div class="table-header">
            <div class="table-title">
              <i class="el-icon-document"></i>
              <span>快递公司列表</span>
            </div>
            <div class="table-stats">
              <span class="stat-item">
                <i class="el-icon-data-line"></i>
                总计：{{pagingData.total || 0}} 家
              </span>
            </div>
          </div>
          
          <ApeTable 
            ref="apeTable" 
            :data="datalist" 
            :loading="loadingStaus" 
            :pagingData="pagingData" 
            @switchPaging="switchPaging" 
            highlight-current-row
            class="data-table">
            
          <el-table-column
            slot="first-column"
              width="80"
              label="序号"
              align="center">
            <template slot-scope="scope">
                <span class="serial-number">{{offset+scope.$index+1}}</span>
            </template>
          </el-table-column>
            
           <el-table-column
              label="快递信息"
              min-width="220">
            <template slot-scope="scope">
                <div class="express-info">
                  <div class="info-row main-info">
                    <i class="el-icon-truck"></i>
                    <span class="info-label">快递名称：</span>
                    <span class="info-value company-name">{{scope.row.express_name}}</span>
                    <el-tag size="mini" type="primary" class="status-tag">
                      <i class="el-icon-check"></i>
                      快递公司
                    </el-tag>
                  </div>
                  <div class="info-row" v-if="scope.row.express_desc">
                    <i class="el-icon-document"></i>
                    <span class="info-label">描述信息：</span>
                    <el-tooltip :content="scope.row.express_desc" placement="top" :disabled="!scope.row.express_desc || scope.row.express_desc.length <= 30">
                      <span class="info-value desc-text">{{scope.row.express_desc | truncate(30)}}</span>
                    </el-tooltip>
                  </div>
                </div>
            </template>
          </el-table-column>
            
          <el-table-column
              label="计费参数"
              min-width="160">
            <template slot-scope="scope">
                <div class="billing-info">
                  <div class="info-row">
                    <i class="el-icon-data-analysis"></i>
                    <span class="info-label">体积系数：</span>
                    <el-tag size="mini" type="warning">
                      <i class="el-icon-data-line"></i>
                      {{scope.row.express_volume_coefficient}}
                    </el-tag>
                  </div>
                  <div class="info-row">
                    <i class="el-icon-data-line"></i>
                    <span class="info-label">燃油费率：</span>
                    <el-tag size="mini" type="danger">
                      <i class="el-icon-money"></i>
                      {{scope.row.fuel_rate}}
                    </el-tag>
                  </div>
                </div>
            </template>
          </el-table-column>
            
          <el-table-column
              label="联系信息"
              min-width="220">
            <template slot-scope="scope">
                <div class="contact-info">
                  <div class="info-row" v-if="scope.row.contact_person">
                    <i class="el-icon-user"></i>
                    <span class="info-label">联系人：</span>
                    <span class="info-value">{{scope.row.contact_person}}</span>
                  </div>
                  <div class="info-row" v-if="scope.row.contact_phone">
                    <i class="el-icon-phone"></i>
                    <span class="info-label">联系电话：</span>
                    <span class="info-value phone-number">{{scope.row.contact_phone}}</span>
                  </div>
                  <div class="info-row" v-if="scope.row.contact_email">
                    <i class="el-icon-message"></i>
                    <span class="info-label">联系邮箱：</span>
                    <el-tooltip :content="scope.row.contact_email" placement="top">
                      <span class="info-value email-text">{{scope.row.contact_email | truncate(20)}}</span>
                    </el-tooltip>
                  </div>
                  <div class="info-row" v-if="scope.row.contact_address">
                    <i class="el-icon-location"></i>
                    <span class="info-label">联系地址：</span>
                    <el-tooltip :content="scope.row.contact_address" placement="top">
                      <span class="info-value address-text">{{scope.row.contact_address | truncate(25)}}</span>
                    </el-tooltip>
                  </div>
                </div>
            </template>
          </el-table-column>
            
          <el-table-column
              label="状态"
              width="120"
              align="center">
            <template slot-scope="scope">
                <div class="status-switch">
                  <span class="switch-label">
                    <i class="el-icon-circle-check" v-if="scope.row.express_status === '1'"></i>
                    <i class="el-icon-circle-close" v-else></i>
                    {{scope.row.express_status === '1' ? '已启用' : '已禁用'}}
                  </span>
                  <el-switch 
                    v-model="scope.row.express_status" 
                    :active-value="'1'" 
                    :inactive-value="'0'" 
                    active-color="#67C23A" 
                    inactive-color="#F56C6C" 
                    @change="changeStatus(scope.row)">
                  </el-switch>
                </div>
            </template>
          </el-table-column>
            
          <el-table-column
            v-if="buttonType=='icon'"
            width="200"
              label="操作"
              align="center"
              fixed="right">
            <template slot-scope="scope">
                <div class="operation-buttons">
                  <el-tooltip effect="dark" content="编辑快递信息" placement="top">
                    <el-button 
                      size="mini" 
                      type="primary"
                      icon="el-icon-edit" 
                      circle
                      @click="editButton(scope.row.id)"
                      class="op-btn edit-btn">
                    </el-button>
              </el-tooltip>
                  
                  <el-tooltip effect="dark" content="区域费用配置" placement="top">
                    <el-button 
                      size="mini" 
                      type="success"
                      icon="el-icon-money" 
                      circle
                      @click="expressArea(scope.row.id)"
                      class="op-btn area-btn">
                    </el-button>
              </el-tooltip>
                  
                  <el-tooltip effect="dark" content="大州附加费配置" placement="top">
                    <el-button 
                      size="mini" 
                      type="warning"
                      icon="el-icon-coin" 
                      circle
                      @click="expressBaf(scope.row.id)"
                      class="op-btn baf-btn">
                    </el-button>
              </el-tooltip>
                </div>
            </template>
          </el-table-column>
        </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <!-- 编辑弹窗 -->
    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <div class="form-container">
          <div class="form-header">
            <i class="el-icon-edit"></i>
            <span>{{drawerData.title}}</span>
          </div>
          
          <el-form 
            :model="formData" 
            :rules="rules" 
            ref="userForm" 
            label-position="right" 
            label-width="100px"
            class="drawer-form">
            
            <div class="form-section">
              <div class="section-title">
                <i class="el-icon-truck"></i>
                <span>基本信息</span>
              </div>
              
              <el-form-item label="快递名称" prop="express_name">
                <el-input 
                  v-model="formData.express_name" 
                  placeholder="请输入快递公司名称"
                  prefix-icon="el-icon-truck">
                </el-input>
              </el-form-item>
              
              <el-form-item label="描述信息" prop="express_desc">
                <el-input 
                  v-model="formData.express_desc"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入快递公司描述信息">
                </el-input>
              </el-form-item>
            </div>
            
            <div class="form-section">
              <div class="section-title">
                <i class="el-icon-data-analysis"></i>
                <span>计费参数</span>
              </div>
              
              <el-form-item label="体积系数" prop="express_volume_coefficient">
                <el-input 
                  v-model="formData.express_volume_coefficient" 
                  type="number" 
                  placeholder="请输入体积系数，如5000,6000"
                  prefix-icon="el-icon-data-analysis">
                </el-input>
              </el-form-item>
              
              <el-form-item label="燃油费率" prop="fuel_rate">
                <el-input 
                  v-model="formData.fuel_rate" 
                  type="number" 
                  placeholder="请输入燃油费率，如0.05,0.06"
                  prefix-icon="el-icon-data-line">
                </el-input>
              </el-form-item>
            </div>
            
            <div class="form-section">
              <div class="section-title">
                <i class="el-icon-user"></i>
                <span>联系信息</span>
              </div>
              
              <el-form-item label="联系人" prop="contact_person">
                <el-input 
                  v-model="formData.contact_person"
                  placeholder="请输入联系人姓名"
                  prefix-icon="el-icon-user">
                </el-input>
              </el-form-item>
              
              <el-form-item label="联系电话" prop="contact_phone">
                <el-input 
                  v-model="formData.contact_phone"
                  placeholder="请输入联系电话"
                  prefix-icon="el-icon-phone">
                </el-input>
              </el-form-item>
              
              <el-form-item label="联系邮箱" prop="contact_email">
                <el-input 
                  v-model="formData.contact_email"
                  placeholder="请输入联系邮箱"
                  prefix-icon="el-icon-message">
                </el-input>
              </el-form-item>
              
              <el-form-item label="联系地址" prop="contact_address">
                <el-input 
                  v-model="formData.contact_address"
                  placeholder="请输入联系地址"
                  prefix-icon="el-icon-location">
                </el-input>
              </el-form-item>
            </div>
            
            <div class="form-section">
              <div class="section-title">
                <i class="el-icon-setting"></i>
                <span>状态设置</span>
              </div>
              
              <el-form-item label="启用状态" prop="express_status">
                <el-switch 
                  v-model="formData.express_status" 
                  :active-value="'1'" 
                  :inactive-value="'0'" 
                  inactive-color="#F56C6C" 
                  active-color="#67C23A"
                  active-text="启用"
                  inactive-text="禁用">
                </el-switch>
              </el-form-item>
            </div>
        </el-form>     
        </div>
      </template>
    </ApeDrawer>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      searchCondition:{
        current_page: 1,
        page_size: 10,
        query: "",
        params: [],
        express_name:''
      },
      loadingStaus: true,
      uploadFileList:[],
      // 表格列表数据
      datalist:[],
      // 分页信息
      pagingData:{
        current_page: 1,
        page_size: 20,
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {},
      // 表单验证
      rules: {
        express_name: [{required: true,message:'快递名称不能为空', trigger: 'blur' }],
        express_desc: [{required: true,message:'快递描述不能为空', trigger: 'blur' }],
        express_status: [{required: true,message:'状态不能为空', trigger: 'blur' }],
        express_volume_coefficient: [{required: true,message:'体积系数不能为空', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '50%',
      },
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  filters: {
    truncate(text, maxLength) {
      if (!text) return ''
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    }
  },
  methods: {
    // 重置搜索
    resetSearch() {
      this.searchCondition.express_name = ''
      this.searchButton()
    },
    // 搜索
    searchButton() {
      this.searchCondition.query= ''
      this.searchCondition.params = []
      if (this.searchCondition.express_name != ''){
        this.searchCondition.query = ' instr(express_name,?)'
        this.searchCondition.params.push(this.searchCondition.express_name)
      }
      this.getList()
    },
    async expressArea(id){
      window.open('/express/'+id+'/area_cost')
    },
    async expressBaf(id){
      window.open('/express/'+id+'/baf_cost')
    },
    // 切换页码操作
    async switchPaging() {
      this.getList()
    },
    async changeStatus(row){
      let res = await this.$api.post('/service/ola_app_express/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('状态修改成功!')
      }
    },
    // 响应添加按钮
    async addButton() {
      this.uploadFileList=[]
      this.formData = {
        id:'',
        express_status:'1'  
      }
      this.drawerData.visible = true
      this.drawerData.title = '添加快递'
      this.drawerData.loading = false
    },
    checkDiscount(rule,value,callback){
      if(value<0 || value>2){
        callback(new Error('折扣必须在0到2之间的小数'))
      }
      callback()
    },
    // 响应编辑按钮
    async editButton(id) {
      this.uploadFileList=[]
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑(ID：'+id+')'
      let res = await this.$api.post('/service/ola_app_express/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let url = '/service/ola_app_express/create'
      if (this.formData.id != ''){
        url = '/service/ola_app_express/update'
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.formData = res.data
      }else{
        this.$message.error(res.message)
        this.drawerData.loading = false
        return
      }
      this.$message.success('保存成功!')
      this.drawerData.loading = false
      this.drawerData.visible = false
      this.getList()
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let id = await this.$api.addDepartment(row)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.getList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteDepartment(id)
      if (info==null) {
        this.$nextTick(async () => {
          this.getList()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {user_role:{system_role_id:0}}
        this.$refs['userForm'].resetFields()
      })
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.staff_image = file
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.staff_image = 0
      this.uploadFileList = fileList
    },
    // 初始化用户列表
    async getList() {
      this.loadingStaus=true
      Object.assign(this.searchCondition,this.$refs['apeTable'].getPagingInfo())
      let res= await this.$api.post('/service/ola_app_express/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.datalist=res.data.list
        this.pagingData.total = res.data.page.total
      }

      this.loadingStaus=false
    }
  },
  mounted() {
    this.getList()
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题区域样式
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  border-radius 12px
  padding 24px
  margin-bottom 20px
  color white
  
  .title-content
    .page-title
      margin 0 0 8px 0
      font-size 24px
      font-weight 600
      display flex
      align-items center
      
      i
        margin-right 12px
        font-size 28px
    
    .page-subtitle
      margin 0
      opacity 0.9
      font-size 14px

// 操作面板样式
.action-card
  background white
  border-radius 12px
  padding 16px 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .action-buttons
    display flex
    gap 8px

// 搜索卡片样式
.search-card
  background white
  border-radius 12px
  padding 20px
  margin-bottom 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .search-header
    display flex
    align-items center
    justify-content space-between
    margin-bottom 16px
    font-weight 600
    color #303133
    
    i
      margin-right 8px
      color #409eff
    
    .reset-all-btn
      color #409eff
      font-size 12px
      
      &:hover
        color #66b1ff
  
  .search-content
    .search-form
      margin 0
      
      /deep/ .el-form-item
        margin-bottom 0
        margin-right 20px

// 表格卡片样式
.table-card
  background white
  border-radius 12px
  padding 20px
  box-shadow 0 2px 12px rgba(0, 0, 0, 0.08)
  
  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 16px
    padding-bottom 12px
    border-bottom 1px solid #f0f0f0
    
    .table-title
      display flex
      align-items center
      font-weight 600
      color #303133
      font-size 16px
      
      i
        margin-right 8px
        color #409eff
        font-size 18px
    
    .table-stats
      .stat-item
        display flex
        align-items center
        font-size 12px
        color #909399
        
        i
          margin-right 4px
          color #409eff
  
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    th
      background #f8f9fa
      color #303133
      font-weight 600
      border-bottom 2px solid #e4e7ed
    
    td
      border-bottom 1px solid #f0f0f0
      padding 12px 8px
    
    tr:hover
      background #f5f7fa

// 序号样式
.serial-number
  display inline-flex
  align-items center
  justify-content center
  width 24px
  height 24px
  background #409eff
  color white
  border-radius 50%
  font-size 12px
  font-weight 600

// 快递信息样式
.express-info
  .info-row
    display flex
    align-items center
    margin-bottom 6px
    font-size 12px
    
    &.main-info
      margin-bottom 8px
      
      .company-name
        font-weight 600
        color #303133
        font-size 13px
      
      .status-tag
        margin-left 8px
        
        i
          margin-right 2px
    
    i
      color #409eff
      margin-right 6px
      font-size 14px
      width 14px
    
    .info-label
      color #909399
      margin-right 4px
      font-weight 500
      min-width 70px
    
    .info-value
      color #303133
      font-weight 500
      
      &.desc-text
        line-height 1.4
      
      &.phone-number
        color #409eff
        font-weight 600
      
      &.email-text
        color #67c23a
        font-weight 500
      
      &.address-text
        color #909399
        font-weight 400

// 计费参数样式
.billing-info
  .info-row
    display flex
    align-items center
    margin-bottom 6px
    font-size 12px
    
    i
      color #409eff
      margin-right 6px
      font-size 14px
      width 14px
    
    .info-label
      color #909399
      margin-right 4px
      font-weight 500
      min-width 60px
    
    .el-tag
      i
        margin-right 2px
        font-size 12px

// 联系信息样式
.contact-info
  .info-row
    display flex
    align-items center
    margin-bottom 6px
    font-size 12px
    
    i
      color #409eff
      margin-right 6px
      font-size 14px
      width 14px
    
    .info-label
      color #909399
      margin-right 4px
      font-weight 500
      min-width 70px
    
    .info-value
      color #303133
      font-weight 500

// 状态开关样式
.status-switch
  display flex
  flex-direction column
  align-items center
  gap 6px
  
  .switch-label
    display flex
    align-items center
    gap 4px
    font-size 11px
    color #909399
    
    i
      font-size 12px
      
      &.el-icon-circle-check
        color #67c23a
      
      &.el-icon-circle-close
        color #f56c6c

// 操作按钮样式
.operation-buttons
  display flex
  gap 6px
  justify-content center
  
  .op-btn
    padding 6px
    
    &.edit-btn
      &:hover
        background #409eff
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(64, 158, 255, 0.3)
    
    &.area-btn
      &:hover
        background #67c23a
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(103, 194, 58, 0.3)
    
    &.baf-btn
      &:hover
        background #e6a23c
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(230, 162, 60, 0.3)
    
    &:hover
      transition all 0.3s ease

// 抽屉表单样式
.form-container
  padding 20px
  
  .form-header
    display flex
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 1px solid #f0f0f0
    font-weight 600
    color #303133
    font-size 16px
    
    i
      margin-right 8px
      color #409eff
      font-size 18px
  
  .drawer-form
    .form-section
      margin-bottom 24px
      padding 16px
      background #f8f9fa
      border-radius 8px
      border-left 4px solid #409eff
      
      .section-title
        display flex
        align-items center
        margin-bottom 16px
        font-weight 600
        color #303133
        font-size 14px
        
        i
          margin-right 6px
          color #409eff
          font-size 16px
    
    /deep/ .el-form-item
      margin-bottom 20px
      
      &:last-child
        margin-bottom 0
      
      .el-form-item__label
        font-weight 600
        color #606266
        
      .el-input
        .el-input__inner
          border-radius 6px
          border-color #DCDFE6
          transition all 0.3s ease
          
          &:focus
            border-color #409EFF
            box-shadow 0 0 0 2px rgba(64,158,255,0.2)
            
      .el-textarea
        .el-textarea__inner
          border-radius 6px
          border-color #DCDFE6
          transition all 0.3s ease
          
          &:focus
            border-color #409EFF
            box-shadow 0 0 0 2px rgba(64,158,255,0.2)

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 16px
    
    .page-title
      font-size 20px
  
  .search-content
    .search-form
      /deep/ .el-form-item
        margin-right 10px
        margin-bottom 10px

// 全局样式优化
/deep/ .el-button
  border-radius 6px
  transition all 0.3s ease
  
  &:hover
    transform translateY(-1px)
    box-shadow 0 4px 12px rgba(64, 158, 255, 0.3)

/deep/ .el-input
  .el-input__inner
    border-radius 6px
    transition all 0.3s ease
    
    &:focus
      box-shadow 0 0 8px rgba(64, 158, 255, 0.2)

/deep/ .el-select
  .el-input__inner
    border-radius 6px

/deep/ .el-tag
  border-radius 6px
  font-weight 500

/deep/ .el-switch
  .el-switch__core
    border-radius 10px
</style>
